'use client';

import { type Table } from '@tanstack/react-table';
import { RefreshCw } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { PromotionItem } from '@/lib/api/promotions';
import { ShopifySyncPromotionButton, WooCommerceSyncPromotionButton } from '@/components/products';

interface PromotionsTableActionsProps {
    table: Table<PromotionItem>;
    onRefresh: () => void;
    isLoading: boolean;
    storeId: string;
}

/**
 * PromotionsTableActions component for table toolbar actions
 */
export const PromotionsTableActions = ({ table, onRefresh, isLoading, storeId }: PromotionsTableActionsProps) => {
    return (
        <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" onClick={onRefresh} disabled={isLoading} className="h-8">
                <RefreshCw className={`mr-2 h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
                Refresh
            </Button>
            <ShopifySyncPromotionButton storeId={storeId} />
            <WooCommerceSyncPromotionButton storeId={storeId} />
        </div>
    );
};

